import React, { useState } from 'react';
import './Sidebar.css';

const Sidebar = ({ navTo, navStyle, tab, logout }) => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const confirmLogout = () => {
    setShowLogoutModal(false);
    if (typeof logout === 'function') logout();
  };

  const tabs = [
    { id: 'overview', label: 'Обзор', icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <rect x="3.5" y="3.5" width="7" height="7" rx="1.5" />
        <rect x="13.5" y="3.5" width="7" height="7" rx="1.5" />
        <rect x="3.5" y="13.5" width="7" height="7" rx="1.5" />
        <rect x="13.5" y="13.5" width="7" height="7" rx="1.5" />
      </svg>
    ) },
    { id: 'payment', label: 'Оплата', icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <rect x="2.5" y="5.5" width="19" height="13" rx="2.5" />
        <path d="M2.5 9.5h19" />
      </svg>
    ) },
    { id: 'referral', label: 'Рефералы', icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <circle cx="9" cy="8" r="3.2" />
        <path d="M3.5 19c0-3 2.5-5 5.5-5s5.5 2 5.5 5" />
        <path d="M16 5.5a3 3 0 0 1 0 5.5M17 14c2.4.4 4 2.2 4 5" />
      </svg>
    ) },
    // { id: 'instructions', label: 'Инструкции', icon: (
    //   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
    //     <path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H12v16H6.5A2.5 2.5 0 0 0 4 21.5z" />
    //     <path d="M20 5.5A2.5 2.5 0 0 0 17.5 3H12v16h5.5a2.5 2.5 0 0 1 2.5 2.5z" />
    //   </svg>
    // ) },
    { id: 'settings', label: 'Настройки', icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <circle cx="12" cy="12" r="3.2" />
        <path d="M19 12a7 7 0 0 0-.1-1.2l2-1.5-2-3.4-2.3 1a7 7 0 0 0-2-1.2l-.3-2.5H8.7l-.3 2.5a7 7 0 0 0-2 1.2l-2.3-1-2 3.4 2 1.5A7 7 0 0 0 4 12c0 .4 0 .8.1 1.2l-2 1.5 2 3.4 2.3-1a7 7 0 0 0 2 1.2l.3 2.5h6.6l.3-2.5a7 7 0 0 0 2-1.2l2.3 1 2-3.4-2-1.5c.1-.4.1-.8.1-1.2z" />
      </svg>
    ) },
    { id: 'documents', label: 'Документы', icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <path d="M6 3h8l4 4v14H6z" />
        <path d="M14 3v4h4M9 12h6M9 16h6" />
      </svg>
    ) },
  ];

  return (
    <aside className="app-aside">
      <div className="aside-logo">
        <div className="aside-logo-icon">
          <svg width="22" height="22" viewBox="0 0 24 24">
            <defs>
              <linearGradient id="riseBolt" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stopColor="#34d399" />
                <stop offset="1" stopColor="#0f8f5f" />
              </linearGradient>
            </defs>
            <path d="M13 2 L5 13 h5 l-1.5 9 L19 10 h-5.5 z" fill="url(#riseBolt)" />
          </svg>
        </div>
        <div>
          <div className="aside-brand">Rise<span className="aside-brand-accent">VPN</span></div>
          <div className="aside-bot">@risevpn_bot</div>
        </div>
      </div>
      <nav className="app-nav">
        {tabs.map((t) => (
          <div
            key={t.id}
            className="navitem"
            onClick={() => navTo(t.id)}
            style={navStyle(tab === t.id)}
          >
            {t.icon}
            <span>{t.label}</span>
          </div>
        ))}
      </nav>
      <div className="aside-footer">
        <div className="aside-help">
          <div className="aside-help-label">Нужна помощь?</div>
          <div className="aside-help-link">
            Напишите в{" "}
            <a
              href="https://t.me/risevpn_help"
              target="_blank"
              rel="noopener noreferrer"
            >
              @risevpn_bot
            </a>
          </div>
        </div>
        <div className="aside-logout-wrap">
          <button
            type="button"
            className="aside-logout"
            onClick={() => setShowLogoutModal(true)}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
            <span>Выйти</span>
          </button>
        </div>
      </div>

      {showLogoutModal && (
        <div className="logout-modal-overlay" onClick={() => setShowLogoutModal(false)}>
          <div className="logout-modal" onClick={(e) => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 12px', color: '#fff' }}>Выход из аккаунта</h3>
            <p style={{ color: '#c8d0d9', margin: '0 0 20px' }}>
              Вы уверены, что хотите выйти?
            </p>
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
              <button
                className="logout-modal-btn cancel"
                onClick={() => setShowLogoutModal(false)}
              >
                Отмена
              </button>
              <button
                className="logout-modal-btn confirm"
                onClick={confirmLogout}
              >
                Да, выйти
              </button>
            </div>
          </div>
        </div>
      )}
    </aside>
  );
};

export default Sidebar;